// extracted by mini-css-extract-plugin
module.exports = {"Loading":"Loading_Loading__UrIMY","spinner":"Loading_spinner__GS2Zn","spin":"Loading_spin__gktBf"};